// extracted by mini-css-extract-plugin
export default {"wrap":"xr-z","fullWidth":"yr-z","items":"zr-z","featureCss":"Ar-z","disabled":"Br-z","imgCss":"Cr-z"};